<template>
  <v-card>
    <v-layout wrap px-3 pt-2>
      <v-flex xs4>
        <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
          <template v-slot:activator="{ on }">
            <v-text-field v-model="dateFormatted" label="From Date"
              hint="MM/DD/YYYY format" readonly persistent-hint prepend-icon="event"
              @blur="date = parseDate(dateFormatted)" v-on="on">
            </v-text-field>
          </template>
          <v-date-picker v-model="date" no-title @input="menu1 = false"></v-date-picker>
        </v-menu>
     </v-flex>
     <v-flex xs4>
        <v-menu v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
          <template v-slot:activator="{ on }">
            <v-text-field v-model="computedDate2Formatted" label="To Date" hint="MM/DD/YYYY format" persistent-hint prepend-icon="event"
              readonly v-on="on" ></v-text-field>
          </template>
          <v-date-picker v-model="date2" no-title @input="menu2 = false"></v-date-picker>
        </v-menu>
     </v-flex>
     <v-flex xs4>
      <v-btn small color="orange darken-2" dark @click="findSonkos" >Filter</v-btn>
      <v-btn small color="orange darken-2" dark @click="resetFilter" >Reset</v-btn>
    </v-flex>
    </v-layout>
    <v-card-title>
      VIP Sonkos
      <v-spacer v-if="user.admin == true"></v-spacer>
      <v-btn v-if="user.admin == true" small color="red darken-2" dark @click="deleteSonkos" >Delete Selected</v-btn>
      <v-spacer></v-spacer>
      <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details class="mr-4"></v-text-field>
      <vue-excel-xlsx class="py-1 px-3 rounded_card v-card v-sheet theme--light blue" dark dense style="color: white;"
          :data="selected"
          :columns="xlsHeaders"
          :filename="'sonkos'"
          :sheetname="'sonkos'"
          >
          Download
      </vue-excel-xlsx>
    </v-card-title>
    <v-data-table :headers="user.admin== true ? headers : editorHeaders" :items="sonkos" :pagination.sync="pagination" v-model="selected" select-all item-key="_id" class="elevation-1" :total-items="amount" :rows-per-page-items="listSize">
      <template slot="headers" slot-scope="props">
        <tr>
          <th v-if="user.admin == true || user.editor == true || user.manager == true">
            <v-checkbox
              primary
              hide-details
              @click.native="toggleAll"
              :input-value="props.all"
              :indeterminate="props.indeterminate"
            ></v-checkbox>
          </th>
          <th v-for="header in props.headers" :key="header.text"
            :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '', header.text=='Action' || header.text=='Subscribe' ? 'text-xs-center' : 'text-xs-left']"
            @click="changeSort(header.value)"
          > 
            {{ header.text }}
            <v-icon>arrow_upward</v-icon>
          </th>
        </tr>
      </template>
      <template v-slot:items="props">
        <tr :active="props.selected" @click="props.selected = !props.selected">
          <td v-if="user.admin == true || user.editor == true || user.manager == true">
            <v-checkbox
              primary
              hide-details
              :input-value="props.selected"
            ></v-checkbox>
          </td>
          <td>{{ props.item.firstName }}</td>
          <td class>{{ props.item.lastName }}</td>
          <td class>{{ props.item.countryCode }}{{ props.item.phone }}</td>
          <td class>{{ props.item.email }}</td>
          <td class v-if="props.item.locationOne">{{ props.item.locationOne.locationName }}</td>
          <td v-else></td>
          <td class>{{ props.item.otp }}</td>
          <td class>
            <span v-if="props.item.active==true">active</span>
            <span v-if="props.item.active==false" style="color:red">inactive</span>
          </td>
          <td class>{{ props.item.createdAt | moment("Do MMM YYYY") }}</td>
          <td class v-if="props.item.packageName">{{ props.item.packageName }}</td>
          <td v-else></td>
          <td class v-if="props.item.packageOption">{{ props.item.packageOption }}</td>
          <td v-else></td>
          <td>
            <span
              v-if="props.item.expired==false"
              style="color: blue; font-weight: bold"
            >Subscribed</span>
            <span v-if="props.item.expired==true" style="color:red; font-weight: bold">Expired</span>
          </td>
          <td class>
            <v-btn color="blue darken-2" v-if="props.item.active==false" small flat @click="activateModal(props.item)">
              Activate
            </v-btn>

             <v-btn color="red" v-if="props.item.active==true" small flat @click="deactivateModal(props.item)">
              Deactivate
            </v-btn>
          </td>
          <td class v-if="user.admin== true">
            <v-btn icon @click="deleteModal(props.item)">
              <v-icon color="red">delete</v-icon>
            </v-btn>
          </td>
          <td class v-if="user.admin== true || user.manager== true">
            <v-btn class="primary" small @click="subscribeModal(props.item)">Subscribe Vip Sonko</v-btn>
          </td>
        </tr>  
      </template>
      <v-alert
        v-slot:no-results
        :value="true"
        color="error"
        icon="warning"
      >Your search for "{{ search }}" found no results.</v-alert>
    </v-data-table>

    <!-- delete dialog -->
    <v-dialog v-model="delete_dialog" max-width="750px">
      <v-toolbar class="red" dark dense>
        <v-toolbar-title>Delete VIP Sonko</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="delete_dialog=false">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 class="pa-2">
              <h5>Are you sure you want to delete this sonko?</h5>
            </v-flex>

            <v-flex xs6 sm6>
              <v-text-field label="First Name" v-model="dataItem.firstName"></v-text-field>
            </v-flex>

            <v-flex xs6 sm6>
              <v-text-field label="Last Name" v-model="dataItem.lastName"></v-text-field>
            </v-flex>

            <v-flex xs6 sm6>
              <v-text-field label="Phone" v-model="dataItem.phone"></v-text-field>
            </v-flex>

            <v-flex xs6 sm6>
              <v-text-field label="Email" v-model="dataItem.email"></v-text-field>
            </v-flex>

            <v-flex xs12>
              <v-btn color="red" class="right" small dark @click="deleteUser" :loading="loader">
                <v-icon left>delete</v-icon>Yes
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
    <!-- end of delete  -->


    <!-- activate dialog -->
    <v-dialog v-model="activate_dialog" max-width="750px">
      <v-toolbar class="primary" dark dense>
        <v-toolbar-title>Activate VIP Sonko</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="activate_dialog=false">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 class="pa-2">
            </v-flex>

            <v-flex xs6 sm6>
              <v-text-field label="First Name" v-model="dataItem.firstName"></v-text-field>
            </v-flex>

            <v-flex xs6 sm6>
              <v-text-field label="Last Name" v-model="dataItem.lastName"></v-text-field>
            </v-flex>

            <v-flex xs6 sm6>
              <v-text-field label="Phone" v-model="dataItem.phone"></v-text-field>
            </v-flex>

            <v-flex xs6 sm6>
              <v-text-field label="Email" v-model="dataItem.email"></v-text-field>
            </v-flex>

            <v-flex xs12>
              <v-btn color="primary" class="right" small dark @click="activate" :loading="loader">
                <v-icon left>thumb_up</v-icon> Activate
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
    <!-- end of activate modal  -->


        <!-- deactivate dialog -->
    <v-dialog v-model="deactivate_dialog" max-width="750px">
      <v-toolbar class="orange darken-2" dark dense>
        <v-toolbar-title>Deactivate VIP Sonko</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="deactivate_dialog=false">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 class="pa-2">
            </v-flex>

            <v-flex xs6 sm6>
              <v-text-field label="First Name" v-model="dataItem.firstName"></v-text-field>
            </v-flex>

            <v-flex xs6 sm6>
              <v-text-field label="Last Name" v-model="dataItem.lastName"></v-text-field>
            </v-flex>

            <v-flex xs6 sm6>
              <v-text-field label="Phone" v-model="dataItem.phone"></v-text-field>
            </v-flex>

            <v-flex xs6 sm6>
              <v-text-field label="Email" v-model="dataItem.email"></v-text-field>
            </v-flex>

            <v-flex xs12>
              <v-btn color="orange darken-2" class="right" small dark @click="deactivate" :loading="loader">
                <v-icon left>thumb_down</v-icon> Deactivate
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
    <!-- end of deactivate modal  -->

    <!-- manual subscription -->
    <v-dialog v-model="manualDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-toolbar flat dense color="primary" dark>
        <v-toolbar-title class="title">Manual Subscription</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon class="mx-0" @click.native="manualDialog = false">
          <v-icon color="white">clear</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card>
        <v-layout wrap class="pa-3">
          <v-flex
            xs12
            sm3
            v-for="packageItem in packages"
            v-bind:key="packageItem._id"
            class="px-2"
          >
            <v-card>
              <v-layout wrap class="pa-3 mb-2">
                <v-flex xs12 class="title text-xs-center">{{packageItem.name}}</v-flex>

                <v-flex xs12 class="pt-3">
                  <p>{{packageItem.description}}</p>
                </v-flex>

                <v-flex xs12 class="pa-1 title text-xs-center">Features</v-flex>

                <v-flex xs12>
                  <ul>
                    <li v-for="(feature, index) in packageItem.features" v-bind:key="index">
                      <v-icon>arrow_right</v-icon>
                      {{feature}}
                    </li>
                  </ul>
                </v-flex>

                <v-flex xs12 class="pa-1 title text-xs-center mt-2">Choose Option</v-flex>

                <v-flex xs12 class="mt-3">
                  <v-layout wrap class="flex-column mb-2">
                    <div v-for="(option, index) in packageItem.options" class="d-flex">
                      <span class="mr-2">{{option.time}}</span>
                      <v-radio-group v-model="radioGroup" class="pt-0 mt-0 package-currency">
                        <v-radio
                          class="mb-0"
                          :key="`ksh${index}`"
                          :label="`Kshs. ${option.cost}`"
                          :value="{'cost': option.cost, '_id': option._id,'time': option.time, 'duration': option.duration, 'currency': 'kes'}"
                        ></v-radio>
                        <v-radio
                          v-if="packageItem.enable_usd == true"
                          class="mb-0"
                          :key="`usd${index}`"
                          :label="`USD ${option.cost_usd}`"
                          :value="{'cost': option.cost_usd, '_id': option._id,'time': option.time, 'duration': option.duration, 'currency': 'usd'}"
                        ></v-radio>
                      </v-radio-group>
                    </div>
                  </v-layout>
                </v-flex>

                <v-flex xs12 class="text-xs-center">
                  <v-btn
                    v-if="radioGroup!=null"
                    class="green darken-1"
                    dark
                    :to="`/vip_sonkos/packages/manual/subscribe/${selectedVipSonko._id}/${packageItem._id}/${radioGroup._id}?time=${radioGroup.time}&&cost=${radioGroup.cost}&&duration=${radioGroup.duration}&&currency=${radioGroup.currency}`"
                  >
                    <v-icon left>check</v-icon>Select Plan
                  </v-btn>
                  <v-btn v-else class="green darken-1" dark>
                    <v-icon left>check</v-icon>Select Plan
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <!-- end of manual subscription -->

  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import moment from 'moment';

export default {
  computed: {
    ...mapGetters(["user"]),
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    computedDate2Formatted () {
      return this.formatDate(this.date2)
    },
  },
  /*props: {
    sonkos: {
      type: Array,
      default: [],
      required: true
    }
  },*/
  data() {
    return {
      search: "",
      delete_dialog: false,
      activate_dialog: false,
      deactivate_dialog: false,
      pagination: {rowsPerPage: 25,page: 1},
      listSize: [5,10,25,50,100,{"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}],
      dataItem: {},
      loader: false,
      headers: [
        {
          text: "First Name",
          align: "left",
          sortable: false,
          value: "firstName"
        },
        { text: "Last Name", value: "lastName" },
        { text: "Phone", value: "phone" },
        { text: "Email", value: "email" },
        { text: "Location", value: "location" },
        { text: "Otp", value: "otp" },
        { text: "Status", value: "status" },
        { text: "Date Created", value: "createdAt" },
        { text: "Package", value: "packageName", sortable: true },
        { text: "Option", value: "packageOption", sortable: true },
        { text: "Expiry", value: "expired", sortable: true },
        { text: "Action", value: "activation" },
        { text: "Delete", value: "action" },
        { text: "Subscribe", value: "subscribe", sortable: true }
      ],
      editorHeaders: [
        {
          text: "First Name",
          align: "left",
          sortable: false,
          value: "firstName"
        },
        { text: "Last Name", value: "lastName" },
        { text: "Phone", value: "phone" },
        { text: "Email", value: "email" },
        { text: "Location", value: "location" },
        { text: "Otp", value: "otp" },
        { text: "Status", value: "status" },
        { text: "Date Created", value: "createdAt" },
        { text: "Package", value: "packageName", sortable: true },
        { text: "Option", value: "packageOption", sortable: true },
        { text: "Expiry", value: "expired", sortable: true },
        { text: "Action", value: "activation" },
      ],
      xlsHeaders: [
        { label: "First Name",field: "firstName"},
        { label: "Last Name", field: "lastName" },
        { label: "Phone", field: "username", dataFormat: this.formatphone },
        { label: "Email", field: "email"},
        { label: "Location", field: "location"},
        { label: "Otp", field: "otp"},
        { label: "Status", field: "active", dataFormat: this.statusFormat },
        { label: "Date Created", field: "createdAt", dataFormat: this.dateFormat },
        { label: "Package", field: "packageName", dataFormat: this.formatpackage, sortable: true  },
        { label: "Option", field: "packageOption", dataFormat: this.formatoption, sortable: true },
        { label: "Expiry", field: "expired", dataFormat: this.formatexpired, sortable: true }
      ],
      selected: [],
      amount: 0,
      sonkos: [],
      date: new Date().toISOString().substr(0, 10),
      dateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
      menu1: false,
      menu2: false,
      date2: new Date().toISOString().substr(0, 10),
      date2Formatted: this.formatDate(new Date().toISOString().substr(0, 10)),
      isFilter: false,
      downloadSonkos: [],
      manualDialog: false,
      selectedVipSonko: {},
      packages: [],
      radios: null,
      radioGroup: null,
    };
  },
  methods: {
    deleteModal(item) {
      this.dataItem = Object.assign({}, item);
      this.delete_dialog = true;
    },
    activateModal(item) {
      this.dataItem = Object.assign({}, item);
      this.activate_dialog = true;
    },
    deactivateModal(item) {
      this.dataItem = Object.assign({}, item);
      this.deactivate_dialog = true;
    },
    deleteUser() {
      this.loader = true;
      const data = this.dataItem;
      const self = this;
      const res = this.$store
        .dispatch("post", { url: "/user/delete/vipsonko", data })
        .then(res => {
          if (res.state) {
            self.loader = false;
            location.reload();
          }
        })
        .finally(() => {});
    },
    activate() {
      this.loader = true;
      const data = this.dataItem;
      const self = this;
      const res = this.$store
        .dispatch("post", { url: "/user/activate", data })
        .then(res => {
          if (res.state) {
            self.loader = false;
            location.reload();
          }
        })
        .finally(() => {});
    },
    deactivate() {
      this.loader = true;
      const data = this.dataItem;
      const self = this;
      const res = this.$store
        .dispatch("post", { url: "/user/deactivate", data })
        .then(res => {
          if (res.state) {
            self.loader = false;
            location.reload();
          }
        })
        .finally(() => {});
    },
    dateFormat(createdAt) {
      return moment(createdAt).format('Do MMM YYYY');
    },
    statusFormat(active) {
      if(active == true) {
        return 'Active';
      }
      return 'Inactive';
    },
    toggleAll () {
      if (this.selected.length) { 
        this.selected = []
      } else {
        this.selected = this.sonkos.slice()
      }
    },
    changeSort (column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    deleteSonkos() {
      const sonkos = [];
      this.selected.forEach((value, index) => {
        sonkos.push(value._id);
      });
      this.loader = true;
      const data = {
        sonkos: sonkos
      };
      const self = this;
      const res = this.$store
        .dispatch("post", { url: "/user/delete/vipsonkos", data })
        .then(res => {
          if (res.state) {
            self.loader = false;
            location.reload();
          }
        })
        .finally(() => {});
    },
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    },
    parseDate (date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    findSonkos() {
      return new Promise((resolve, reject) => {
          this.isFilter = true;
          const self = this;
          let search = this.search.trim().toLowerCase();
          const {rowsPerPage, page} = this.pagination;
          let sortBy = this.pagination.sortBy;
          let sortOrder  = -1;
          if(this.pagination.descending == false) {
            sortOrder = 1;
          }
          const data = {
            fromDate: this.date,
            toDate: this.date2,
            page: page,
            keyword: search,
            perpage: rowsPerPage,
            sortBy: sortBy,
            sortOrder: sortOrder
          };
          const res = this.$store
            .dispatch("post", { url: "/user/vipsonkos/date", data })
            .then(res => {
              self.sonkos = res.sonkos;
              self.downloadSonkos = res.sonkos;
              const {
                    sortBy,
                    descending,
                    page,
                    rowsPerPage
                } = self.pagination;
                self.amount = res.amount;
                resolve();
            });
      });
    },
    getSonkos() {
      return new Promise((resolve, reject) => {
          let search = this.search.trim().toLowerCase();
          if(search !== '') {
            search = `/`+search;
          }
          const {rowsPerPage, page} = this.pagination;
          let sortBy = '/'+this.pagination.sortBy;
          let order  = -1;
          if(this.pagination.descending == false) {
            order = 1;
          }
          let sortOrder = '/'+order;
          this.$store.dispatch("get", `/user/admin/vipsonkos`+sortBy+sortOrder+'/'+page+`/`+rowsPerPage+search).then(res => {
            this.sonkos = res.sonkos;
            this.downloadSonkos = res.sonkos;
            const {
                sortBy,
                descending,
                page,
                rowsPerPage
            } = this.pagination;
            this.amount = res.amount;
            resolve();
          });
      });
    },
    resetFilter() {
      this.date = new Date().toISOString().substr(0, 10);
      this.dateFormatted= this.formatDate(new Date().toISOString().substr(0, 10));
      this.menu1 = false;
      this.menu2 = false;
      this.date2 = new Date().toISOString().substr(0, 10);
      this.date2Formatted = this.formatDate(new Date().toISOString().substr(0, 10));
      this.getSonkos();
    },
    formatphone(username) {
      return username.replace("+", "");
    },
    selectRow(valu) {
      alert(valu);
    },
    formatpackage(packageName) {
      if(packageName != null) {
        return packageName;
      }
      return '';
    },
    getPackages() {
      this.$store.dispatch("get", "/packages/vip").then(res => {
        this.packages = res.packages;
      });
    },
    subscribeModal(item) {
      this.selectedVipSonko = Object.assign({}, item);
      this.manualDialog = true;
    },
  },
  watch: {
    date (val) {
      this.dateFormatted = this.formatDate(this.date);
      this.date2Formatted = this.formatDate(this.date2);
    },
    pagination: {
        handler() {
            if(this.isFilter == true){
              this.findSonkos();
            } else{
              this.getSonkos();
            }
        },
        deep: true
    },
    search() {
        if(this.isFilter == true){
          this.findSonkos();
        } else{
          this.pagination.page = 1;
          this.pagination.rowsPerPage = 25;
          this.getSonkos();
        }
    }
  },
  mounted() {
        this.getSonkos();
        this.getPackages();
  }
};
</script>